import React from "react";
import PredictionPage from "../../components/PredictionPage";

function BrentCrudeOil() {
  return (
    <PredictionPage
      title="Brent Crude Oil"
      content="This is the Brent Crude Oil AI Trading Predictions page."
      canonical="/commodities/brent-crude-oil-ai-trading-predictions"
      categoryKey="nav.commodities"
      categoryPath="/commodities"
      symbol="BRENTOIL"
    />
  );
}

export default BrentCrudeOil;
